module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/faceWash_9f158d.png";